import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {TTheme} from '../types';
import {ProgressService} from './progress.service';
import {BehaviorSubject, Observable} from 'rxjs';

const THEMES: TTheme[] = [
    'ai-media',
    'intel',
    'light'
];

const DEFAULT = THEMES[0];

@Injectable()
export class ThemesService {
    private renderer!: Renderer2;
    private current = DEFAULT;
    private current$$: BehaviorSubject<TTheme> = new BehaviorSubject<TTheme>(DEFAULT);

    constructor(
        rendererFactory: RendererFactory2,
        private progress: ProgressService
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    static getAll(): TTheme[] {
        return THEMES;
    }

    get$(): Observable<TTheme> {
        return this.current$$.asObservable();
    }

    switchTo(t?: TTheme): void {
        // t = 'intel'
        const theme = (!t) ? DEFAULT : t;
        if (this.current !== theme) {
            const fileName = [[theme, 'theme'].join('-'), 'css'].join('.');
            const currentStyleSheet = this.findExistedStylesheet(this.current);
            if (currentStyleSheet) {
                currentStyleSheet.disabled = this.current !== theme;
            }
            this.current = theme;
            this.current$$.next(this.current);
            const newStyleSheet = this.findExistedStylesheet(theme);
            if (newStyleSheet) {
                newStyleSheet.disabled = false;
            } else {
                this.progress.start();
                const head = document.getElementsByTagName('head').item(0);
                const newStyle = this.renderer.createElement('link');
                this.renderer.setAttribute(newStyle, 'rel', 'stylesheet');
                this.renderer.setAttribute(newStyle, 'href', fileName);
                this.renderer.appendChild(head, newStyle);
                setTimeout(() => {
                    this.progress.stop();
                }, 1000);
            }
        } else {
            console.warn('Switched to the same theme');
        }


    }

    private findExistedStylesheet(name: string): CSSStyleSheet | undefined {
        let styleSheet;
        const a = Array.from(document.styleSheets).filter(s => {
            if (!s.href) {
                return false;
            }
            const match = (s.href as string).match(name) || [];

            return !!match.length;
        });
        if (a.length) {
            styleSheet = a.pop();
        }

        return styleSheet;
    }

}
